import React, { FC } from 'react';

import s from './container.module.scss';

export const Container: FC = ({ children }) => (
  <div className={s.container}>{children}</div>
);
